import axios from "axios";

export async function startCheckout(lookupKey: string, relatedId?: string) {
  const res = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/api/payments/checkout`,
    { lookup_key: lookupKey, origin_url: window.location.origin, related_id: relatedId || null },
    { headers: { Authorization: `Bearer ${localStorage.getItem("nl_token")}` }, withCredentials: true }
  );
  window.location.href = res.data.checkout_url;
}
